import React, { useMemo } from 'react';

import { useKioskManager } from '../../../hooks/useKioskManager';
import Icon from '../icon/Icon';
import type { IconType } from '../icon/types';
import type { Coordinates } from '../types';
import styles from './youAreHerePin.module.scss';

export type IconWithCoordinatesProps = {
  coordinates: Coordinates;
  iconType: IconType;
  size?: number;
};

export const IconWithCoordinates: React.FC<IconWithCoordinatesProps> = ({
  coordinates,
  iconType,
  size,
}) => {
  const { kiosk, kioskMode } = useKioskManager();
  const translatedCoordinates = useMemo(() => {
    const pinIconDimensions = {
      width: size || 94,
      height: size || 94,
    };

    const x = coordinates.x - pinIconDimensions.width / 2;
    const y = coordinates.y - pinIconDimensions.height;

    return { top: y, left: x };
  }, [coordinates.x, coordinates.y, size]);

  return (
    <div
      className={`${styles.container} ${
        kiosk && kioskMode && styles[kiosk.model]
      }`}
      style={translatedCoordinates}
      data-testid="youAreHerePin"
    >
      <Icon icon={iconType} size={size || 'full'} theme="none" />
    </div>
  );
};
